const HEADER_STYLES = {
  DROPDOWN: 0,
  SEARCH: 1,
  RANGE: 2
};

export { HEADER_STYLES };
